import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("threadops_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("threadops_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => {
        setUser(r.data);
        localStorage.setItem("threadops_user", JSON.stringify(r.data));
      })
      .catch(() => {
        localStorage.removeItem("threadops_token");
        localStorage.removeItem("threadops_user");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password, remember = false) => {
    const r = await api.post("/auth/login", { email, password, remember });
    localStorage.setItem("threadops_token", r.data.token);
    localStorage.setItem("threadops_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  }, []);
  const logout = useCallback(() => {
    localStorage.removeItem("threadops_token");
    localStorage.removeItem("threadops_user");
    setUser(null);
    window.location.href = "/login";
  }, []);
  const value = useMemo(() => ({ user, loading, login, logout }), [user, loading, login, logout]);
  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}
export const useAuth = () => useContext(AuthContext);
